export const openPopup = (url: string, name: string) => {
  const width = 640;
  const height = 480;
  const left = window.screen.width / 2 - width / 2;
  const top = window.screen.height / 2 - height / 2;

  return window.open(
    url,
    name,
    `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${width}, height=${height}, top=${top}, left=${left}`,
  );
};

export const polling = (popup: null | Window, callback: (query: null | URLSearchParams) => void, include: string) => {
  const closeDialog = (pollingInterval: ReturnType<typeof setInterval>) => {
    clearInterval(pollingInterval);
    if (!popup) {
      return;
    }
    popup.close();
  };

  const pollingInterval = setInterval(() => {
    if (!popup || popup.closed) {
      closeDialog(pollingInterval);
      callback(null);
    }

    try {
      if (popup?.location.hostname && !popup.location.hostname.includes(include)) {
        if (popup.location.search) {
          callback(new URLSearchParams(popup.location.search));
        } else {
          callback(null);
        }

        closeDialog(pollingInterval);
      }
    } catch {
      // Ignore DOMException: Blocked a frame with origin from accessing a cross-origin frame.
      // A hack to get around same-origin security policy errors in IE.
    }
  }, 500);
};
